import React from "react";
import { withTranslation } from "react-i18next";
import { Card, Table, Button, Label } from "reactstrap";

const AuditSummaryCardSkeleton: React.FC = ({t}: any) => {
	return (
		<Card className="shadow p-4 mb-4 border-0 rounded">

			{/* Filters Skeleton */}
			<div className="bg-light p-3 rounded shadow-sm mb-4">
				<div className="d-flex justify-content-start align-items-center mb-3 gap-2">
					<h5 className="fw-semibold mb-0 placeholder col-2"></h5>
					<Button
						color="danger"
						size="sm"
						className="btn-label placeholder col-1"
						disabled
					/>
				</div>

				<div className="row g-3">
					{[1, 2, 3].map((i) => (
						<div key={i} className="col-md-3 placeholder-glow">
							<Label className="form-label text-muted small mb-1">{t("student.details.activities.loading")}</Label>
							<div className="form-control placeholder col-12 py-2"></div>
						</div>
					))}
				</div>
			</div>

			{/* Table Skeleton */}
			<div className="mb-5 d-flex flex-column gap-1">
				<h5 className="fw-semibold">{t("footprints.activities")}</h5>
				<div className="table-responsive border rounded shadow-sm">
					<Table className="align-middle table-nowrap mb-0">
						<thead className="table-light">
							<tr>
								{['Date', 'User', 'Team', 'Role', 'Check-in', 'Check-out', 'Remarks', 'Points'].map((head, idx) => (
									<th key={idx}>{head}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{[1, 2, 3, 4].map((row) => (
								<tr key={row} className="placeholder-glow">
									{[...Array(8)].map((_, col) => (
										<td key={col}><span className="placeholder col-8"></span></td>
									))}
								</tr>
							))}
						</tbody>
					</Table>
				</div>
			</div>
		</Card>
	);
};

export default withTranslation()(AuditSummaryCardSkeleton);
